/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, Add, BadgeOutlined, FlagOutlined, MailOutline, PhoneAndroid} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import {FECHACHECKIN} from "../../Modulo_Motor_Reservas/Constantes";
import indicativos from '../../Utilidades/Indicativos.json'


const Formulario_Reserva_Datos = ({...props}) => {
    const [fechaInicio, setFechaInicio] = useState(new Date())


    useEffect(() => {
        let fechaEscogida = props.props.getValues(FECHACHECKIN)
        setFechaInicio(fechaEscogida)


    }, [props.props.watch(FECHACHECKIN)]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}

            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Identificacion</Typography>
                </Grid>

                <Grid container size={{xs: 4, sm: 4, md: 4}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo Id'} dato={'tipoCc'} {...props}
                                   opciones={['C.C', 'T.E']}
                    />
                </Grid>

                <Grid container size={{xs: 8, sm: 8, md: 8}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Datos del huesped</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>

                <Grid container size={4}>
                    <IngresoSelect Icono={Add} nombre={'Indicativo'} dato={'indicativo'} {...props}
                                   opciones={indicativos.map((it) => it.nameES)}
                    />
                </Grid>

                <Grid container size={8}>
                    <IngresoTexto Icono={PhoneAndroid} nombre={'Num WhatsApp'} dato={'celular'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Reserva_Datos